import script from "./WelcomePopup.vue?vue&type=script&setup=true&lang=js"
export * from "./WelcomePopup.vue?vue&type=script&setup=true&lang=js"

import "./WelcomePopup.vue?vue&type=style&index=0&id=985ca0fe&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-985ca0fe"]])

export default __exports__